import React from 'react';

import { AppContext } from 'src/_AppContainer';

// TODO: add type
export const useAppContext = () => React.useContext<any>(AppContext);
